import { Component } from 'react';
import PropTypes from 'prop-types';

export default function ShowComponent(MyComponent) {
  class ShowComponentDecorator extends Component {
    render() {
      const { show } = this.props;

      return show ? <MyComponent {...this.props} /> : null;
    }
  }

  ShowComponentDecorator.propTypes = {
    show: PropTypes.bool,
  };

  ShowComponentDecorator.defaultProps = {
    show: false,
  };

  return ShowComponentDecorator;
}
